import {
  identifyAnalyticsUser,
  resetAnalyticsUser,
  trackProductEvent,
  trackSignupMarketingConversion,
  type AnalyticsProperties,
} from '@/lib/analytics';
import type { User } from '@/types/auth';

// Keep conversion identity separate from generic analytics properties. The
// email is used only by the consented enhanced-conversion path.
type SignupConversionIdentity = Pick<User, 'id' | 'email'>;

export const identifyAuthenticatedUser = (user: Partial<User> & Record<string, unknown>) => {
  identifyAnalyticsUser(user);
};

export const resetAuthenticatedUser = () => {
  resetAnalyticsUser();
};

export const trackLogoutCompleted = () => {
  trackProductEvent('Logout Completed');
};

export const trackLoginCompleted = (properties: AnalyticsProperties) => {
  trackProductEvent('Login Completed', properties);
};

export const trackLoginOtpRequested = (properties: AnalyticsProperties) => {
  trackProductEvent('Login OTP Requested', properties);
};

export const trackOAuthAuthCompleted = (
  memberStatus: 'new' | 'existing' | undefined,
  properties: AnalyticsProperties,
  user: SignupConversionIdentity,
) => {
  if (memberStatus === 'new') {
    trackSignupCompleted(properties, user);
    return;
  }

  trackLoginCompleted(properties);
};

export const trackSignupStarted = (properties: AnalyticsProperties) => {
  trackProductEvent('Signup Started', properties);
};

export const trackSignupSubmitted = (properties: AnalyticsProperties) => {
  trackProductEvent('Signup Submitted', properties);
};

export const trackSignupCompleted = (
  properties: AnalyticsProperties,
  user: SignupConversionIdentity,
) => {
  trackSignupMarketingConversion(properties, {
    userId: user.id,
    email: user.email,
  });
};
